import React, {useEffect, useState} from 'react';
import {Container, Grid, } from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {AddCircle } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import ApiServices from 'services/ApiServices';
import {showMessageSuccessSimple, showMessagePersonalizedPosition} from 'services/SweetAlert'
import LoadingSpinner from 'components/LoadingSpinner';
import Title from 'components/TitleWithIcon';
import {functions} from 'constants/index';
import DialogLoadingMessage from 'components/LoadingMessage/index'

let iddetalle = ''
function ComponenteCaptacionDeFallecidos(props) {
    iddetalle = props.tableData
    let description = [
        {name: "Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "Datos requeridos (*)."}
    ];    
    const [apiErrors,setApiErrors] = useState([]);
    const classes = useStyles(),
        [mensajeBuscando, setMensajeBuscando] = useState({loading: false, title:''}),
        [mensaje, setMensaje] = useState({loading: false, title:''}),
        [updateForm, setUpdateForm] = React.useState(true),
        [loading, setLoading] = React.useState(false);
        let mensajeErrorCUI={error: false, mensaje:""}, cuiRegExp = /^[\\d0-9]{13}$/; 
        let idDepartamento = ''; let idMunicipio = '';
    const obtenerDepartamentos =async ()=>{
        // setLoadingRequest(true)
        let newElements= Object. assign({}, elements); 
        if(props.catalogos?.departamentos?.length === 0 ){
            try{
                let response = await ApiServices.departamentos.listRegisterCriteria();
                newElements.coddepto.list=[];
                if(response.error){
                    // setCargandoDatos(false);
                }else {  
                        var datos = response.data
                        Object.keys(datos).forEach((element, key, _array) =>{
                            if(datos[element].id === "23" || datos[element].id === "24" || datos[element].id === "25"){
                            }else{
                                newElements.coddepto.list.push({
                                    id: datos[element].id,
                                    name: datos[element].name,
                                    municipios:[]
                                });
                            }
                        }) 
                        // elements.codmunic.value = null
                        // props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS(newElements.departamentoNacimiento.list)
                    } 
                }catch(exception){
                    newElements.coddepto.list=[];
                }
        }else{
            newElements.coddepto.list = props.catalogos.departamentos
        }
        // setLoadingRequest(false)
        setElements(newElements);
    };
    //cargamos los municipios en base al departamento seleccionado        
    const obtenerMunicipios =async (event)=>{
        let newElements= Object. assign({}, elements); 
        elements.codmunic.value = null
        if(event?.target?.value) idDepartamento = event.target.value;
        else idDepartamento = event

        const currentMunicipality = props.catalogos?.municipios?.filter( ({departamentoId}) => Number(departamentoId) === Number(idDepartamento));
        if(currentMunicipality?.length > 0) {
            newElements.codmunic.list=currentMunicipality;    
            return;    
        }        
        try{
            ApiServices.municipios.searchCriteria.clear();
            ApiServices.municipios.searchCriteria.setOperator("and");
            ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamento);
            ApiServices.municipios.setIsPublic(true);
            let response =await ApiServices.municipios.listRegisterCriteria();
            if(response.error){
                newElements.codmunic.list=[];
                // setCargandoDatos(false);
            }else {                
                newElements.codmunic.list=response.data;
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)
            }
        }catch(exception){
            newElements.codmunic.list=[];
        }
        setElements(newElements);
    };
    const obtenerAuxiliaturas =async (event)=>{
        setMensaje({loading: true, title: 'Cargando catálogo de auxiliaturas ...'})        
        let newElements= Object. assign({}, elements); 
        elements.codauxiliatura.list = []
        elements.codauxiliatura.value = null
        if(event?.target?.value) idMunicipio = event.target.value;
        else idMunicipio = event
        try{
            ApiServices.auxiliaturas.searchCriteria.clear();
            ApiServices.auxiliaturas.searchCriteria.setOperator("and");
            ApiServices.auxiliaturas.searchCriteria.addEquals("departamentoId",idDepartamento);
            ApiServices.auxiliaturas.searchCriteria.addEquals("municipioId",idMunicipio);
            ApiServices.auxiliaturas.searchCriteria.addEquals("estado",1);
            ApiServices.auxiliaturas.setIsPublic(true);
            let response =await ApiServices.auxiliaturas.listRegisterCriteria();
            if(response.error){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                newElements.codauxiliatura.list=[];
            }else {                
                newElements.codauxiliatura.list = response.data
            }
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }            
            newElements.codauxiliatura.list=[];
        }
        setElements(newElements);
        setMensaje({loading: false, title: ''})
    };    
    const validacionCUI = (cui)=>{
        if(!cui){
            mensajeErrorCUI={error: false, mensaje:""}
            return mensajeErrorCUI;
        }        
        
        if(!cuiRegExp.test(cui)){
            mensajeErrorCUI={error: true, mensaje:"CUI menor de 13 dígitos, Ingrese un CUI válido, sin espacios"}
            return mensajeErrorCUI;
        }
        mensajeErrorCUI={error: false, mensaje:"CUI valido"}
        return mensajeErrorCUI;
    }
    const AgregarCaptacionDeFallecido= async ()=>{
        var saveData = {}
        var datosDelFormulario = elements
        validacionCUI(datosDelFormulario.cui.value)
        if (mensajeErrorCUI.error){
            elements.cui.isError=mensajeErrorCUI.error;
            elements.cui.errorMessages=mensajeErrorCUI.mensaje
            let errores=[];
            errores[0]={"attribute": "cui", "message":mensajeErrorCUI.mensaje}
            setApiErrors(errores);            
        }else{ 
            Object.keys(datosDelFormulario).forEach((element, key, _array) =>{
                if(datosDelFormulario[element].idelement === 'coddepto' || datosDelFormulario[element].idelement === 'codmunic' || datosDelFormulario[element].idelement === 'codauxiliatura'){
                    if(datosDelFormulario[element].idelement === 'codauxiliatura' && datosDelFormulario[element].value?.id === 1 && datosDelFormulario[element].value?.name === ''){
                        saveData[datosDelFormulario[element].idelement] = '';
                    }else saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value.id;
                }
                else if(datosDelFormulario[element].elementType === 'date'){
                    saveData[datosDelFormulario[element].idelement] = new Date(datosDelFormulario[element].value);
                    // saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value;
                }
                else if(datosDelFormulario[element].idelement === 'password'){
                    saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value;
                }
                else if(datosDelFormulario[element].idelement !== 'titleDatosDeLaMadre' && datosDelFormulario[element].idelement !== 'titleDatosDelPadre' &&
                    datosDelFormulario[element].idelement !== 'titleDatosFallecidos' && datosDelFormulario[element].idelement !== 'titleFolio' &&
                    datosDelFormulario[element].idelement !== 'titleRestoDeDatos' && datosDelFormulario[element].idelement !== 'firmaElectronica'
                ) {
                    saveData[datosDelFormulario[element].idelement] = typeof datosDelFormulario[element].value === 'string' ?  datosDelFormulario[element].value.toUpperCase(): datosDelFormulario[element].value;
                }
            }) 
            saveData.iddetalle = iddetalle?.iddetalle
            setMensaje({loading: true, title: 'Cancelando ...'})
            try{
                const response =  await ApiServices.captacionFallecidos.modificarFallecido(saveData)
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message)
                }else{
                    showMessageSuccessSimple('¡BIEN!', response.data)
                    props.actualizarTabla()
                    Cancelar();
                }   
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
            }                 
        }
        setMensaje({loading: false, title: ''})
    };
        
    const Cancelar=()=>{
        props.closeModal()
    };    

    const borrarValorEstado = (event)=>{
        if(event?.target?.value === "") elements.estado.value = "";
    }
    const keyPress = async (event) => {
        let newElements= Object. assign({}, elements); 
        if (event.key === "Enter") {
            setMensajeBuscando({loading: true, title: 'Obteniendo estado. Espere un momento ...'})
            if(event.target.value === ''){
                showMessagePersonalizedPosition('warning','¡Oopss!', 'Por favor ingrese No. Boleta','center')
            }else{
                try{
                    const response =  await ApiServices.Padron.obtenerStatus(event.target.value)
                    if(response.error!==null){
                        showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                    }else{
                        showMessagePersonalizedPosition('success','¡BIEN!', 'Estado asignado correctamente.','center')
                        newElements.estado.value = response.data
                    }   
                }catch(exception){
                    if (exception.status===404) {
                        showMessagePersonalizedPosition('error','Oopss!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
                    }
                    else {
                        showMessagePersonalizedPosition('error','Oopss!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
                    }
                }                             
            }
            setElements(newElements);
            setMensajeBuscando({loading: false, title: ''})
        }
    };

    const [elements,setElements] = useState({
        titleFolio:{
            idelement: "titleFolio",title:'Datos Generales del Folio', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },    
            nrofolio: {
                idelement: "nrofolio",  value:'', label: "No. Folio", pattern:"",  disabled: true,
                validators: ['required'], errorMessages:['Ingrese No. Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            año: {
                idelement: "año",  value:'', label: "Año de folio", pattern:"", disabled: true,
                validators: ['required'], errorMessages:['Ingrese Año de Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            coddepto: {
                idelement: "coddepto", value: null, label: "Departamento", pattern:"", validators: ['required'], disabled: true,
                errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerMunicipios,
            },
            codmunic: {
                idelement: "codmunic", value: null, label: "Municipio", pattern:"", validators: ['required'], disabled: true,
                errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [], handler:obtenerAuxiliaturas
            },
            codauxiliatura: {
                idelement: "codauxiliatura", value: {id:1, name:''}, label: "Auxiliatura", pattern:"", validators: ['required'], 
                errorMessages:['Seleccione auxiliatura'], isError:false, elementType:'autocompleteV2', list: [], disabled: true,
            },
            fechainicio: { 
                idelement: "fechainicio", value: '', label: "Ingrese Fecha Inicio", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Inicio'], isError:false, elementType:'date', disabled: false, disabled: true,
            },            
            fechafinal: { 
                idelement: "fechafinal", value: '', label: "Ingrese Fecha Fin", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Fin'], isError:false, elementType:'date', disabled: false, disabled: true,
            },                        
        titleRestoDeDatos:{
            idelement: "titleRestoDeDatos",title:'Ingrese el Resto de los Datos', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            nroboleta: {
                idelement: "nroboleta",  value: '', label: "No. Boleta", pattern:"", keyPress: keyPress, handler: borrarValorEstado,
                validators: ['requireds'], errorMessages:['Ingrese No. boleta, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            cui: {
                idelement: "cui",  value:'', label: "Ingrese CUI del DPI", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese CUI, sin espacios al inicio y final'], isError:false, elementType:'input',
            },
            nroorden: {
                idelement: "nroorden",  value:'', label: "Ingrese No. orden de Cédula", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese No. orden de Cédula, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nroregistro: {
                idelement: "nroregistro",  value:'', label: "Ingrese No. registro de Cédula", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese No. registro de Cédula, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            estado: {
                idelement: "estado",  value:'', label: "Ingrese Estado", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Estado, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            fechanacimiento: { 
                idelement: "fechanacimiento", value:'', label: "Ingrese Fecha Nacimiento", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Nacimiento'], isError:false, elementType:'date', disabled: true,
            },
            fechadefuncion: { 
                idelement: "fechadefuncion", value:'', label: "Ingrese Fecha Defunción", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Defunción'], isError:false, elementType:'date', disabled: true,
            },
        titleDatosFallecidos:{
            idelement: "titleDatosFallecidos",title:'Ingrese los Datos del Fallecido', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            apellido1fallecido: {
                idelement: "apellido1fallecido",  value:'', label: "Ingrese Primer Apellido", pattern:"", disabled: true,
                validators: ['required'], errorMessages:['Ingrese Primer Apellido, sin espacios al inicio y final'], isError:false, elementType:'input',
            },
            apellido2fallecido: {
                idelement: "apellido2fallecido",  value:'', label: "Ingrese Segundo Apellido", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Segundo Apellido, sin espacios al inicio y final'], isError:false, elementType:'input',
            },
            apellido3fallecido: {
                idelement: "apellido3fallecido",  value:'', label: "Ingrese Apellido de Casada", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Apellido de Casada, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
            nombre1fallecido: {
                idelement: "nombre1fallecido",  value:'', label: "Ingrese Primer nombre", pattern:"", 
                validators: ['required'], errorMessages:['Ingrese Primer Nombre, sin espacios al inicio y final'], isError:false, elementType:'input', disabled: true,
            },
            nombre2fallecido: {
                idelement: "nombre2fallecido",  value:'', label: "Ingrese Segundo nombre", pattern:"", 
                validators: ['requireds'], errorMessages:['Ingrese Segundo Nombre, sin espacios al inicio y final'], isError:false, elementType:'input', disabled: true,
            },
        titleDatosDelPadre:{
            idelement: "titleDatosDelPadre",title:'Ingrese los Datos del Padre', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            apellido1padre: {
                idelement: "apellido1padre",  value:'', label: "Ingrese Primer Apellido del Padre", pattern:"", 
                validators: ['requireds'], errorMessages:['Ingrese Primer Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', disabled: true,
            },
            apellido2padre: {
                idelement: "apellido2padre",  value:'', label: "Ingrese Segundo Apellido del Padre", pattern:"", 
                validators: ['requireds'], errorMessages:['Ingrese Segundo Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', disabled: true,
            },
            nombrepadre: {
                idelement: "nombrepadre",  value:'', label: "Ingrese Nombres del Padre", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Nombres del Padre, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
        titleDatosDeLaMadre:{
            idelement: "titleDatosDeLaMadre",title:'Ingrese los Datos de la Madre', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },
            apellido1madre: {
                idelement: "apellido1madre",  value:'', label: "Ingrese Primer Apellido de la Madre", pattern:"", 
                validators: ['requireds'], errorMessages:['Ingrese Primer Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', disabled: true,
            },
            apellido2madre: {
                idelement: "apellido2madre",  value:'', label: "Ingrese Segundo Apellido de la Madre", pattern:"", 
                validators: ['requireds'], errorMessages:['Ingrese Segundo Apellido, sin espacios al inicio y final'], isError:false, elementType:'input', disabled: true,
            },
            nombremadre: {
                idelement: "nombremadre",  value:'', label: "Ingrese Nombres de la Madre", pattern:"", disabled: true,
                validators: ['requireds'], errorMessages:['Ingrese Nombres de la Madre, sin espacios al inicio y final'], isError:false, elementType:'input', 
            },
        firmaElectronica:{
            idelement: "firmaElectronica",title:'Ingrese Firma Electrónica', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },            
            password: { idelement: "password",  value:'', label: 'Ingrese contraseña *', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },        
    });    
    const setearInformacionRENAP = ()=>{
        let newElements= Object. assign({}, elements); 
        newElements.nrofolio.value = props.tableData?.datosfolio?.idfolio||''
        newElements.año.value = props.tableData?.datosfolio?.año||''
        newElements.coddepto.value = {id: props.tableData?.datosfolio?.departamentov?.id, name: props.tableData?.datosfolio?.departamentov?.name}||''
        newElements.codmunic.value = (
            (props.datosDelCiudadanoAComparar?.renap?.datosfolio.auxiliatura === null) ?
                {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.municipiov?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.municipiov?.name}:
            {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.municipio?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.municipio?.name}
        )
        newElements.codauxiliatura.value = (
            (props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura) ?
                {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.name}
            : {id:1, name:''}
        )
        newElements.fechainicio.value = new Date(props.datosDelCiudadanoAComparar?.renap?.datosfolio?.fechainicio) ||''
        newElements.fechafinal.value = new Date(props.datosDelCiudadanoAComparar?.renap?.datosfolio?.fechafinal) ||''
        newElements.nroboleta.value = ''
        newElements.cui.value = props.datosDelCiudadanoAComparar?.renap?.cui||''
        newElements.nroorden.value = props.datosDelCiudadanoAComparar?.renap?.nroorden||''
        newElements.nroregistro.value = props.datosDelCiudadanoAComparar?.renap?.nroregist||''
        newElements.estado.value = ''
        newElements.fechanacimiento.value = new Date(props.datosDelCiudadanoAComparar?.renap?.fechanacimiento) ||''
        newElements.fechadefuncion.value = new Date(props.datosDelCiudadanoAComparar?.renap?.fechadefuncion)||''
        newElements.apellido1fallecido.value = props.datosDelCiudadanoAComparar?.renap?.apellido1fallecido||''
        newElements.apellido2fallecido.value = props.datosDelCiudadanoAComparar?.renap?.apellido2fallecido||''
        newElements.apellido3fallecido.value = props.datosDelCiudadanoAComparar?.renap?.apellido3fallecido||''
        newElements.nombre1fallecido.value = props.datosDelCiudadanoAComparar?.renap?.nombre1fallecido||''
        newElements.nombre2fallecido.value = props.datosDelCiudadanoAComparar?.renap?.nombre2fallecido||''
        newElements.apellido1padre.value = props.datosDelCiudadanoAComparar?.renap?.apellido1padre||''
        newElements.apellido2padre.value = props.datosDelCiudadanoAComparar?.renap?.apellido2padre||''
        newElements.nombrepadre.value = props.datosDelCiudadanoAComparar?.renap?.nombrepadre?.trim() ||''
        newElements.apellido1madre.value = props.datosDelCiudadanoAComparar?.renap?.apellido1madre||''
        newElements.apellido2madre.value = props.datosDelCiudadanoAComparar?.renap?.apellido2madre||''
        newElements.nombremadre.value = props.datosDelCiudadanoAComparar?.renap?.nombremadre?.trim() ||''
        setElements(newElements);
        showMessagePersonalizedPosition('success','¡BIEN!', 'Datos de RENAP ingresados','center')
    }
    const setearInformacionPADRON = ()=>{
        let newElements= Object. assign({}, elements); 
        newElements.nrofolio.value = props.tableData?.datosfolio?.idfolio||''
        newElements.año.value = props.tableData?.datosfolio?.año||''
        newElements.coddepto.value = {id: props.tableData?.datosfolio?.departamentov?.id, name: props.tableData?.datosfolio?.departamentov?.name}||''
        newElements.codmunic.value = (
            (props.datosDelCiudadanoAComparar?.renap?.datosfolio.auxiliatura === null) ?
                {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.municipiov?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.municipiov?.name}:
            {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.municipio?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.municipio?.name}
        )
        newElements.codauxiliatura.value = (
            (props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura) ?
                {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.name}
            : {id:1, name:''}
        )
        newElements.fechainicio.value = new Date(props.datosDelCiudadanoAComparar?.renap?.datosfolio?.fechainicio) ||''
        newElements.fechafinal.value = new Date(props.datosDelCiudadanoAComparar?.renap?.datosfolio?.fechafinal) ||''
        newElements.nroboleta.value = props.datosDelCiudadanoAComparar?.padron?.nroboleta||''
        newElements.cui.value = props.datosDelCiudadanoAComparar?.padron?.dpi?.cui||''
        newElements.nroorden.value = props.datosDelCiudadanoAComparar?.padron?.dpi?.ordenCedulaRef||''
        newElements.nroregistro.value = props.datosDelCiudadanoAComparar?.padron?.dpi?.registroCedulaRef||''
        newElements.estado.value = props.datosDelCiudadanoAComparar?.padron?.statusPadron||''
        newElements.fechanacimiento.value = new Date(props.datosDelCiudadanoAComparar?.padron?.fechaNacimiento) ||''
        newElements.fechadefuncion.value = new Date(props.datosDelCiudadanoAComparar?.renap?.fechadefuncion)||''
        newElements.apellido1fallecido.value = props.datosDelCiudadanoAComparar?.padron?.primerApellido||''
        newElements.apellido2fallecido.value = props.datosDelCiudadanoAComparar?.padron?.segundoApellido||''
        newElements.apellido3fallecido.value = props.datosDelCiudadanoAComparar?.padron?.tercerApellido||''
        newElements.nombre1fallecido.value = props.datosDelCiudadanoAComparar?.padron?.primerNombre||''
        newElements.nombre2fallecido.value = props.datosDelCiudadanoAComparar?.padron?.segundoNombre||''
        newElements.apellido1padre.value = props.datosDelCiudadanoAComparar?.padron?.complemento?.primerApePadre||''
        newElements.apellido2padre.value = props.datosDelCiudadanoAComparar?.padron?.complemento?.segundoApePadre||''
        newElements.nombrepadre.value = ((props.datosDelCiudadanoAComparar?.padron?.complemento?.primerNomPadre) ? (props.datosDelCiudadanoAComparar?.padron?.complemento?.primerNomPadre) : '') + ((props.datosDelCiudadanoAComparar?.padron?.complemento?.segundoNomPadre) ? (' '+props.datosDelCiudadanoAComparar?.padron?.complemento?.segundoNomPadre):'')
        newElements.apellido1madre.value = props.datosDelCiudadanoAComparar?.padron?.complemento?.primerApeMadre||''
        newElements.apellido2madre.value = props.datosDelCiudadanoAComparar?.padron?.complemento?.segundoApeMadre||''
        newElements.nombremadre.value = ((props.datosDelCiudadanoAComparar?.padron?.complemento?.primerNomMadre ? props.datosDelCiudadanoAComparar?.padron?.complemento?.primerNomMadre:'')) + ((props.datosDelCiudadanoAComparar?.padron?.complemento?.segundoNomMadre)? (' '+props.datosDelCiudadanoAComparar?.padron?.complemento?.segundoNomMadre):'')
        setElements(newElements);
        showMessagePersonalizedPosition('success','¡BIEN!', 'Datos de PADRÓN ingresados','center')
    }
    const setearInformacionHomonimos = ()=>{
        if(props.isSelectHomonimos){
            if(Object.keys(props.datosHomonimos).length !== 0){
                let newElements= Object. assign({}, elements); 
                newElements.nrofolio.value = props.tableData?.datosfolio?.idfolio||''
                newElements.año.value = props.tableData?.datosfolio?.año||''
                newElements.coddepto.value = {id: props.tableData?.datosfolio?.departamentov?.id, name: props.tableData?.datosfolio?.departamentov?.name}||''
                newElements.codmunic.value = (
                    (props.datosDelCiudadanoAComparar?.renap?.datosfolio.auxiliatura === null) ?
                        {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.municipiov?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.municipiov?.name}:
                    {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.municipio?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.municipio?.name}
                )
                newElements.codauxiliatura.value = (
                    (props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura) ?
                        {id: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.id, name: props.datosDelCiudadanoAComparar?.renap?.datosfolio?.auxiliatura?.name}
                    : {id:1, name:''}
                )
                newElements.fechainicio.value = new Date(props.datosDelCiudadanoAComparar?.renap?.datosfolio?.fechainicio) ||''
                newElements.fechafinal.value = new Date(props.datosDelCiudadanoAComparar?.renap?.datosfolio?.fechafinal) ||''
                newElements.nroboleta.value = props.datosHomonimos?.nroboleta||''
                newElements.cui.value = props.datosHomonimos?.cui||''
                newElements.nroorden.value = props.datosHomonimos?.nroorden||''
                newElements.nroregistro.value = props.datosHomonimos?.nroregistro||''
                newElements.estado.value = props.datosHomonimos?.estado
                newElements.fechanacimiento.value = new Date(props.datosHomonimos?.fechanacimiento)
                newElements.fechadefuncion.value = new Date(props.datosDelCiudadanoAComparar?.renap?.fechadefuncion)
                newElements.apellido1fallecido.value = props.datosHomonimos?.apellido1fallecido||''
                newElements.apellido2fallecido.value = props.datosHomonimos?.apellido2fallecido||''
                newElements.apellido3fallecido.value = props.datosHomonimos?.apellido3fallecido||''
                newElements.nombre1fallecido.value = props.datosHomonimos?.nombre1fallecido||''
                newElements.nombre2fallecido.value = props.datosHomonimos?.nombre2fallecido||''
                newElements.apellido1padre.value = props.datosHomonimos?.apellido1padre||''
                newElements.apellido2padre.value = props.datosHomonimos?.apellido2padre||''
                newElements.nombrepadre.value = props.datosHomonimos?.nombrepadre
                newElements.apellido1madre.value = props.datosHomonimos?.apellido1madre||''
                newElements.apellido2madre.value = props.datosHomonimos?.apellido2madre||''
                newElements.nombremadre.value = props.datosHomonimos?.nombremadre
                setElements(newElements);
                showMessagePersonalizedPosition('success','¡BIEN!', 'Datos de homónimos ingresados','center')
            }
        }else{
            showMessagePersonalizedPosition('warning','¡Oopss!', 'Por favor seleccione un homónimo','center')
        }
    }
    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Actualizar datos y Cancelar","icon": <AddCircle />,"callback":AgregarCaptacionDeFallecido,"loading":loading, disabled:loading, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",}, 
    });
    const setearInformacionFormulario=()=>{
        setearInformacionRENAP()
    };
    useEffect(() => {
        if(props.open){
            setearInformacionFormulario()
            obtenerDepartamentos()
        }
    }, [props.open])
    useEffect(() => {
        if(props.isSelectHomonimos){
            if(Object.keys(props.datosHomonimos).length !== 0){
                setearInformacionHomonimos()
            }
        }
    }, [props.isSelectHomonimos])

    return (
        <div id="scroller" className={classes.root}>
            <DialogLoadingMessage open={mensaje.loading} title={mensaje.title}/>
            <DialogLoadingMessage open={mensajeBuscando.loading} title={mensajeBuscando.title}/>
            <LoadingSpinner open={loading} message={'Procesando ...'}/>

            <div className={classes.colorComponente}>
                <Grid container >
                    <Title title="Complete el formulario para la captación de fallecidos" icon={"/menu/Document.png"}/>
                    <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>
                        <Form apiErrors={apiErrors}  elements= {elements}  buttonList={buttonList} BotonCerrar={Cancelar} description={description}/>
                    </Grid>                
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(ComponenteCaptacionDeFallecidos);